import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmployeeDetailsComponent } from './employee-details/employee-details.component';
import { EmployeesDocsComponent } from './employees-docs/employees-docs.component';
import { EmployeesAddComponent } from './employees-add/employees-add.component';
import { EmployeesLinkedSitesComponent } from './employees-linked-sites/employees-linked-sites.component';
import { EmployeesNotificationsComponent } from './employees-notificaions/employees-notifications/employees-notifications.component';
import { EmployeesTabsComponent } from './employees-tabs/employees-tabs.component';
import { AuthGuard } from '../guards/auth.guard';
import { RBACGuard } from '../guards/rbac.guard';
import { RBACService } from '../shared/rbac.service';
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';
import {EmployeesImporterComponent} from "./employees-importer/employees-importer.component";
import {EmployeesDocsImporterComponent} from "./employees-docs-importer/employees-docs-importer.component";
import {EmployeesSitesVisitedComponent} from "./employees-sites-visited/employees-sites-visited.component";
import {EmployeesSitesWorkedOnComponent} from "./employees-sites-worked-on/employees-sites-worked-on.component";
import {EmployeesAssignedFormsComponent} from "./employees-assigned-forms/employees-assigned-forms.component";
import {
  EmployeesNotificationsTabsComponent
} from './employees-notificaions/employees-notifications-tabs/employees-notifications-tabs.component';
import { EmployeesRbacRolesComponent } from './employees-rbac-roles/employees-rbac-roles.component';
import { EmployeesLayoutComponent } from './employees-layout/employees-layout.component';

const routes: Routes = [
  {
    // The Employees shell carries two independently gated tabs, Employees and Access Requests (SC-301).
    // No RBACGuard here on purpose: either permission is enough to reach the page, and the component
    // redirects when neither is held. A guard listing both would have to allow either anyway, so the
    // decision belongs in one place rather than two.
    path: 'employees',
    component: EmployeesLayoutComponent,
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'employees/add',
    component: EmployeesAddComponent,
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'employees/importer',
    component: EmployeesImporterComponent,
    canActivate: [
      AuthGuard,
      RBACGuard
    ],
    data: {
      permissions: [
        RBACService.getPermission(RBACService.RBAC_F.F_EMPLOYEES, RBACService.RBAC_A.A_CREATE)
      ],
      exact: true
    }
  },
  {
    path: 'employees/docs-importer',
    component: EmployeesDocsImporterComponent,
    canActivate: [
      AuthGuard,
      RBACGuard
    ],
    data: {
      permissions: [
        RBACService.getPermission(RBACService.RBAC_F.F_EMPLOYEES_TRAINING_COMPETENCIES, RBACService.RBAC_A.A_CREATE)
      ],
      exact: true
    }
  },
  {
    path: 'employees/:user_id',
    component: EmployeesTabsComponent,
    canActivate: [
      AuthGuard
    ],
    children: [
      {
        pathMatch: 'full', path: '', redirectTo: 'details'
      },
      { path: 'details', component: EmployeeDetailsComponent },
      { path: 'docs', component: EmployeesDocsComponent },
      // Manage Sites (employee site associations) requires the Premium SITES feature.
      { path: 'linked-sites', component: EmployeesLinkedSitesComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.SITES } },
      // Notifications (notification roles) is a Premium feature.
      { path: 'notifications', component: EmployeesNotificationsTabsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.NOTIFICATION_ROLES } },
      { path: 'rbac-roles', component: EmployeesRbacRolesComponent },
      // Assigned Forms is a Premium FORMS surface; employee site visit/worked-on reports are Premium.
      { path: 'assigned-forms', component: EmployeesAssignedFormsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.FORMS } },
      { path: 'sites-visited', component: EmployeesSitesVisitedComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.SITE_ACCESS } },
      { path: 'sites-worked-on', component: EmployeesSitesWorkedOnComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.SITES } }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeesRoutingModule {}
